








































































































































































































































































import {getDicts} from '@/api/system/dict/data';
import {api} from '@/plugins/api';
import {msgSuccess} from '@/plugins/element';
import {SysConfig} from '@/types/api-beans';
import {download, selectDictLabel} from '@/utils/ruoyi';
import {ElForm} from 'element-ui/types/form';
import {SchemaFormField} from 'v-schema-form';

import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'SysConfigList'
})
export default class SysConfigList extends Vue {
  // 参数表格数据
  public configList: SysConfig[] = [];
  // 表单参数
  public form: SysConfig = {
    configId: undefined,
    configName: undefined,
    configKey: undefined,
    configValue: undefined,
    configType: 'Y',
    remark: undefined
  };
  // 选中数组
  public ids = [];
  // 遮罩层
  public loading = true;
  // 非多个禁用
  public multiple = true;
  // 是否显示弹出层
  public open = false;
  // 查询参数
  public queryParams = {
    pageNum: 1,
    pageSize: 10,
    configName: undefined,
    configKey: undefined,
    configType: undefined
  };
  // 表单校验
  public rules = {
    configName: [
      {required: true, message: '参数名称不能为空', trigger: 'blur'}
    ],
    configKey: [
      {required: true, message: '参数键名不能为空', trigger: 'blur'}
    ],
    configValue: [
      {required: true, message: '参数键值不能为空', trigger: 'blur'}
    ]
  };
  public searchForm = {};
  public searchFormSchema: SchemaFormField = {
    props: {
      inline: true
    },
    fields: {
      configName: {
        type: 'string',
        title: '参数名称',
        placeholder: '请输入参数名称'
      },
      configKey: {
        type: 'string',
        title: '参数键名',
        placeholder: '请输入参数键名'
      },
      // configType: {
      //   type: 'select',
      //   title: '参数键名'
      // },
      '[start, end]': {
        type: 'daterange',
        title: '创建时间'
      }
    }
  } as SchemaFormField;
  // 显示搜索条件
  public showSearch = true;
  // 非单个禁用
  public single = true;
  // 弹出层标题
  public title = '';
  // 总条数
  public total = 0;
  // 类型数据字典
  public typeOptions = [];

  public cancel() {
    this.open = false;
    this.reset();
  }

  public created() {
    this.getList();
    getDicts('sys_yes_no').then(response => {
      this.typeOptions = response.data;
    });
  }

  /** 查询参数列表 */
  public async getList() {
    this.loading = true;
    try {
      const data = await api.system.config.list.r(Object.assign({
        page: this.queryParams.pageNum - 1,
        size: this.queryParams.pageSize
      }, this.searchForm ?? {}));
      this.configList = data.content!;
      this.total = data.totalElements!;
    } catch (e) {
    } finally {
      this.loading = false;
    }
  }

  /** 新增按钮操作 */
  public handleAdd() {
    this.reset();
    this.open = true;
    this.title = '添加参数';
  }

  /** 刷新缓存按钮操作 */
  public handleRefreshCache() {
    api.system.config.refreshCache.r().then(() => {
      msgSuccess('刷新成功');
    });
  }

  /** 删除按钮操作 */
  public handleDelete(row) {
    const configIds = row.configId || this.ids;
    this.$confirm('是否确认删除参数编号为"' + configIds + '"的数据项?', '警告', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      return api.system.config.remove.r({
        configIds: configIds
      });
    }).then(() => {
      this.getList();
      msgSuccess('删除成功');
    });
  }

  /** 导出按钮操作 */
  public handleExport() {
    const queryParams = this.queryParams;
    this.$confirm('是否确认导出所有参数数据项?', '警告', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function() {
      return api.system.config.export.r(queryParams);
    }).then(data => {
      download(data);
    });
  }

  /** 搜索按钮操作 */
  public handleQuery() {
    this.queryParams.pageNum = 1;
    this.getList();
  }

  public handleSelectionChange(selection) {
    this.ids = selection.map(item => item.configId);
    this.single = selection.length != 1;
    this.multiple = !selection.length;
  }

  /** 修改按钮操作 */
  public handleUpdate(row) {
    this.reset();
    const configId = row.configId || this.ids;
    api.system.config.getInfo.requestData(configId).then(data => {
      this.form = data;
      this.open = true;
      this.title = '修改参数';
    });
  }

  public reset() {
    this.form = {
      configId: undefined,
      configName: undefined,
      configKey: undefined,
      configValue: undefined,
      configType: 'Y',
      remark: undefined
    };
    (this.$refs['form'] as ElForm)?.resetFields();
  }

  /** 重置按钮操作 */
  public resetQuery() {
    this.searchForm = {};
    this.handleQuery();
  }

  /** 提交按钮 */
  public submitForm() {
    (this.$refs['form'] as ElForm).validate(valid => {
      if (valid) {
        if (this.form.configId != undefined) {
          api.system.config.update.r(this.form).then(() => {
            msgSuccess('修改成功');
            this.open = false;
            this.getList();
          });
        } else {
          api.system.config.add.r(this.form).then(() => {
            msgSuccess('新增成功');
            this.open = false;
            this.getList();
          });
        }
      }
    });
  }

  public typeFormat(row, column) {
    return selectDictLabel(this.typeOptions, row.configType);
  }
}
